/* eslint-disable import/prefer-default-export */
export const objtype = {
  WIRELESS_AP: 'WIRELESSAP',
  AP_CONTROLLER: 'AP_CONTROLLER',
  POE: 'POE',
};

export const objtypeName = {
  [objtype.WIRELESS_AP]: '무선 AP',
  [objtype.AP_CONTROLLER]: 'AP 컨트롤러',
};



// WEBPACK FOOTER //
// ./src/constants/objtype.js